import { useWelcomeVideo } from "../hooks/useWelcomeVideo";
import { WelcomeVideoModal } from "./WelcomeVideoModal";

/**
 * Mounts the one-time onboarding welcome video. Exists so the hook can be
 * called unconditionally, below the root layout's early mobile return.
 */
export function WelcomeVideoGate() {
  const { isOpen, videoId, dismiss } = useWelcomeVideo();

  return (
    <WelcomeVideoModal isOpen={isOpen} onClose={dismiss} videoId={videoId} />
  );
}
